import { useDebouncedState } from '@/legacy-src/hooks/useDebouncedState'

import { useGetTherapistLocations } from '@/src/domains/therapist-filters/hooks/useGetTherapistLocations'

export interface UseTherapistSessionLocationFilter {
  serviceId?: number
  value: number[]
  callback: (value: number[]) => void
  wait?: number
}

export const useTherapistSessionLocationFilter = ({
  serviceId,
  value: initialValue,
  callback,
  wait,
}: UseTherapistSessionLocationFilter) => {
  const { data } = useGetTherapistLocations(serviceId)

  const { value, onChange } = useDebouncedState<number[]>({
    value: initialValue,
    callback,
    wait,
  })

  const handleChange = (checked: boolean, districtId: number) => {
    if (checked) {
      onChange([...value, districtId])
    } else {
      onChange(value.filter((id) => id !== districtId))
    }
  }

  return { value, handleChange, data }
}
